import { createSelector } from '@reduxjs/toolkit';
import { getPropertyLinkQuery } from './getPropertyLinkQuery';
import stringifyQueryValues from 'lib/search/stringifyQueryValues';

export const getPropertyLinkQueryString = createSelector(getPropertyLinkQuery, (query) => stringifyQueryValues(query));
